import BlogsPage from "./components/BlogsPage";

export default function App({ categories }) {
  return <BlogsPage categories={categories} />;
}